import { atom } from 'jotai';

import { SuggestionTabs } from '../../types/suggestion.js';
import { suggestionTabs } from '../../utils/getTabs.js';

export const activeSuggestionTabAtom = atom<SuggestionTabs>(
  suggestionTabs.ACTIVE,
);
